import { useEffect } from 'preact/hooks';
import { useSettings } from '../../contexts/settings-context';

// This component handles dynamic font loading
export const FontLoader = () => {
  const { settings } = useSettings();

  useEffect(() => {
    // Only load Open Dyslexic font when it's selected
    if (settings.fontFamily.includes('OpenDyslexic')) {
      // Create a link element for the font
      const link = document.createElement('link');
      link.href =
        'https://cdn.jsdelivr.net/npm/open-dyslexic@1.0.3/woff/OpenDyslexic-Regular.woff';
      link.rel = 'preload';
      link.as = 'font';
      link.type = 'font/woff';
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);

      // Add the font-face definition
      const style = document.createElement('style');
      style.textContent = `
        @font-face {
          font-family: 'OpenDyslexic';
          src: url('https://cdn.jsdelivr.net/npm/open-dyslexic@1.0.3/woff/OpenDyslexic-Regular.woff') format('woff');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
      `;
      document.head.appendChild(style);
    }
  }, [settings.fontFamily]);

  // This component doesn't render anything
  return null;
};
